// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from "react";
import { reaction } from "mobx";
// semantic-ui
import { Sidebar, Segment, Menu } from "semantic-ui-react";
import { auditStore } from "services/state";

export default class PageWithSidebar extends React.Component {
  disposeReaction = null;
  state = {
    isOpen: false
  }
  componentDidMount(){
    this.disposeReaction = reaction(
      () => auditStore.isOpen,
      isOpen => this.setState({isOpen})
    );
  }
  componentWillUnmount(){
    this.disposeReaction();
  }
  render() {
    const { sidebarContent, children, SidebarPusherProps } = this.props;
    const className = this.state.isOpen ? 'overflow-hidden' : null;
    return (
      <Sidebar.Pushable
        as={Segment}
        style={{
          display: "flex",
          flex: "1 1 auto",
          overflow: "hidden",
          border: "none",
          margin: 0,
          borderRadius: 0,
          boxShadow: "none",
        }}
      >
        <Sidebar
          as={Menu}
          inverted
          attached
          borderless
          vertical
          visible
          style={{
            margin: 0,
            borderRadius: 0,
            flex: "0 0 auto",
            position: "relative",
            overflowY: "scroll",
            width: "260px",
          }}
        >
          {sidebarContent}
        </Sidebar>
        <Sidebar.Pusher
          style={{
            marginLeft: 0,
            position: "absolute",
            flex: "1 1 auto",
            height: "100%",
            overflow: "auto",
            width: "calc(100% - 260px)",
          }}
          className={className}
          {...SidebarPusherProps}
        >
          {children}
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  }
}